'use client';
import {
  NotFoundPage,
  mockNotFoundContent as static404Content,
} from '@pixel-party';
import {Snackbar} from '@pixel-party/Snackbar/v2';
import {useEffect} from 'react';
import {
  GFIBER_404,
  REDIRECTION_SNACKBAR_MESSAGE,
  REDIRECTION_TIME_404,
} from '@/lib/utils/constants';

export default function NotFound() {
  const data = {
    title: static404Content.title,
    description: static404Content.description,
    showBanner: true,
    banner: static404Content.banner,
  };
  const delay = REDIRECTION_TIME_404;
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional omission as window.location is not a reactive dependency
  useEffect(() => {
    let redirectTimer: ReturnType<typeof setTimeout> | null = null;
    redirectTimer = setTimeout(() => {
      window.location.href = `${GFIBER_404}?redirect_from=${window.location.href}`;
    }, delay);

    return () => {
      if (redirectTimer) {
        clearTimeout(redirectTimer);
      }
    };
  }, [delay]);

  return (
    <>
      <NotFoundPage {...data} />
      <Snackbar
        verticalPosition="bottom"
        horizontalPosition="right"
        message={REDIRECTION_SNACKBAR_MESSAGE}
        open={true}
        autoHideDuration={delay}
      />
    </>
  );
}
